import { render } from "./long-insure-detail.vue?vue&type=template&id=555882b8&scoped=true&ts=true"
import script from "./long-insure-detail.vue?vue&type=script&lang=ts"
export * from "./long-insure-detail.vue?vue&type=script&lang=ts"

import "./long-insure-detail.vue?vue&type=style&index=0&id=555882b8&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555882b8"]])

export default __exports__